export default {
	state: () => ({
		viewCount: null,
	}), 
	mutations: {
		setViewCount(state, value) {
			state.viewCount = value;
		},
	},
	actions: {
		setViewCount(state, value) {
			this.commit("setViewCount", value);
		},
	}
}